module.exports = __webpack_public_path__ + "img/xigeshiyeBanner.c9e87776.png";